//
import Cliente from '../../shared/entity/Cliente';
import { celularMask } from '../../shared/helper';
import React from 'react';
import { Dimensions, StyleSheet, Text } from 'react-native';
import colors from '../../colors';
import { TXT_M } from '../../constants';
import Touchable from '../Generic/Touchable';

const DEVICE_WIDTH = Dimensions.get('window').width;
const DEVICE_HEIGHT = Dimensions.get('window').height;

type Props = {
  cliente?: Cliente;
  onClick: (x: Cliente) => void;
};

const ItemSelecaoCliente: React.FC<Props> = (props) => {
  const { cliente, onClick } = props;

  return (
    <Touchable style={styles.itemResposta} onPress={() => onClick(cliente)}>
      <Text>
        {cliente.nome} - {celularMask(cliente.celular)}
      </Text>
    </Touchable>
  );
};

const styles = StyleSheet.create({
  radioLabel: {
    fontSize: TXT_M,
    color: colors.darkGrey
  },
  viewTaxa: {
    flexDirection: 'row',
    alignSelf: 'center',
    marginTop: 15,
    justifyContent: 'center',
    alignItems: 'center'
  },
  labelTaxa: { marginRight: 5, fontSize: TXT_M, color: colors.primary },
  valorTaxa: { fontSize: TXT_M, color: colors.values },

  selectView: {
    borderWidth: 2,
    borderColor: colors.lightGrey,
    borderRadius: 5,
    padding: 10
  },
  select: {
    borderWidth: 0,
    padding: 5
    // backgroundColor: '#ff0'
    // WebkitAppearance: 'none',
    // '-moz-appearance': none,
    // textIndent: 1
    // // text-overflow: '',
  },
  value: {
    fontSize: TXT_M
  },

  itemResposta: {
    borderWidth: 1,
    borderColor: colors.lightGrey,
    borderRadius: 5,
    padding: 10,
    marginBottom: 10
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flex: 1,
    width: '100%',
    marginBottom: 15
  }
});

export default ItemSelecaoCliente;
